import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appSharedDirective]'
})
export class SharedDirectiveDirective {
  
  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if(event.code === 'Space') {
      return event.preventDefault();
    }
  }
}
